import React from "react";
import { createRoot } from "react-dom/client";
import LoadBoard from "./LoadBoard"; // Importe o componente FlipBoard
import styled, { createGlobalStyle } from "styled-components";
import { toKg, toReal } from "./formatters";

// Estilos globais podem ser movidos para um arquivo separado se preferir
const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    background: #1e1e21;
  }

  /* Esconder o app quando estiver em retrato */
  @media (orientation: portrait) {
    #app-wrapper { display: none; }
    #rotate-warning { display: flex; }
  }

  /* Exibir o app quando estiver em paisagem */
  @media (orientation: landscape) {
    #app-wrapper { display: block; }
    #rotate-warning { display: none; }
  }
`;

const RotateWarning = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #fff;
  min-height: 100vh;
  padding: 24px;
  font-family: Arial, sans-serif;
  font-size: 18px;
`;

function App() {
  // const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const fetchAllLoads = async (page) => {
    try {
      const response = await fetch(
        `https://api-control-tower.vercel.app/all-loads?limit=16&page=${page}`
      );
      const res = await response.json();
      console.log(`Página ${page + 1} carregada`);
      return res.data;
    } catch (error) {
      console.error(`Erro ao buscar a página ${page + 1}:`, error);
      return [];
    }
  };

  const columns = [
    { key: "emissora", title: "Orig.", length: 3 },
    {
      key: "separator",
      title: "➡️",
      length: 1,
      formatter: () => ":",
    },
    { key: "destino", title: "Dest.", length: 3 },
    {
      key: "peso_total",
      title: "Peso Total",
      length: 11,
      isDecimal: true,
      isNumeric: true,
      formatter: (value) => `${toKg(value)}`,
    },
    {
      key: "frete_total",
      title: "Frete Total",
      length: 11,
      isDecimal: true,
      isNumeric: true,
      formatter: (value) => `${toReal(value)}`,
    },
  ];

  return (
    <>
      <GlobalStyle />
      {/* Aviso em modo retrato */}
      <RotateWarning id="rotate-warning">
        <div>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📱</div>
          <div>Por favor, vire seu dispositivo para o modo horizontal para visualizar o painel.</div>
        </div>
      </RotateWarning>

      {/* App apenas em modo paisagem */}
      <div id="app-wrapper">
        <LoadBoard
          fetchData={fetchAllLoads}
          columns={columns}
          autoFlip={true}
          autoFlipTime={12000}
          showPagination={false}
          formatters={{ toKg, toReal }}
          emptyItem={{
            emissora: "",
            destino: "",
            peso_total: "",
            frete_total: "",
          }}
        />
      </div>
    </>
  );
}

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
